import ATTACHMENT_OVERFLOW_STRATEGY from '@/lib/composer/ATTACHMENT_OVERFLOW_STRATEGY.js';

const normalizeComposerAttachmentOverflowStrategy = (value) => {
  const normalizedValue = String(value || '')
    .trim()
    .toLowerCase();

  if (normalizedValue === ATTACHMENT_OVERFLOW_STRATEGY.summarize) {
    return ATTACHMENT_OVERFLOW_STRATEGY.summarize;
  }

  return ATTACHMENT_OVERFLOW_STRATEGY.truncate;
};

export default normalizeComposerAttachmentOverflowStrategy;
